module.exports = __webpack_public_path__ + "img/46_30.1331e3ca.png";